import { combineReducers } from "redux";
import authReducer from "./authReducer";
import userManagementReducer from "./userManagementReducer"; // Faculty
import attendanceReducer from "./attendanceReducer";
import dashboardReducer from "./dashboardReducer";


const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  userManagement: userManagementReducer,
  attendance: attendanceReducer,
});

export default rootReducer;
